import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import DSTooltip, { TooltipType } from '@elliemae/ds-basic/Tooltip';
import { PopperInteractions, PopperPositions } from '@elliemae/ds-basic/Popper';
import DSToggle from '@elliemae/ds-basic/form/Toggle';
import DSButton from '@elliemae/ds-basic/Button';
import QueryAdd from '@elliemae/ds-icons/QueryAdd';
import ParenthesisRemove from '@elliemae/ds-icons/ParenthesisRemove';
import MoreOptionsVert from '@elliemae/ds-icons/MoreOptionsVert';
import { DSIconColors, DSIconSizes } from '@elliemae/ds-basic/Icon';
import { DELAY_CLOSE, DELAY_OPEN, TOOLBAR_ANIMATION_DURATION } from '../helpers/constants.js';
import { ToolBarAnimation } from '../ToolBarAnimation/ToolBarAnimation.js';
import DragContainerController from '../DragContainerController/DragContainerController.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-shared/Animations/GrowRight';
import '@elliemae/ds-icons/GripperVertical';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _convertPropToCssClas = convertPropToCssClassName('query-builder-and-or-controller'),
    cssClassName = _convertPropToCssClas.cssClassName,
    classNameBlock = _convertPropToCssClas.classNameBlock,
    classNameElement = _convertPropToCssClas.classNameElement,
    mainModifier = _convertPropToCssClas.mainModifier,
    classNameBlockModifier = _convertPropToCssClas.classNameBlockModifier;
/**
 * condition-display-step: required to avoid the cache of the trigger
 *
 * @param e
 * @param isOpen
 */


var AndOrController = /*#__PURE__*/function (_Component) {
  _inherits(AndOrController, _Component);

  var _super = _createSuper(AndOrController);

  function AndOrController(props) {
    var _this;

    _classCallCheck(this, AndOrController);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnterRow", function (e) {
      _this.handleTooltipRow(true); // this.handleMouseMove(e)

    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (e) {
      if (!_this.contenerRef.current) return;
      var mouse = e.clientY;

      var _this$contenerRef$cur = _this.contenerRef.current.getBoundingClientRect(),
          height = _this$contenerRef$cur.height;

      var delta = height / 2;

      var topDiff = _this.myRef.current.getBoundingClientRect().top;

      var refHeight = _this.myRef.current.getBoundingClientRect().height;

      _this.setState({
        top: mouse - topDiff - refHeight / 2 - delta
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeaveRow", function () {
      _this.handleTooltipRow(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTooltipRow", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });

      var handleTooltipGroup = _this.props.handleTooltipGroup;
      handleTooltipGroup(isOpen);
    });

    _this.contenerRef = /*#__PURE__*/React.createRef();
    _this.myRef = /*#__PURE__*/React.createRef();
    _this.state = {
      isOpen: false,
      top: 0,
      right: -2
    };
    return _this;
  }

  _createClass(AndOrController, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleRuleContainerOperator = _this$props.handleRuleContainerOperator,
          handleRuleContainerUnGroup = _this$props.handleRuleContainerUnGroup,
          labelOn = _this$props.labelOn,
          labelOff = _this$props.labelOff,
          condition = _this$props.condition,
          showDragController = _this$props.showDragController,
          allowUnGroup = _this$props.allowUnGroup,
          buttonActionSize = _this$props.buttonActionSize,
          buttonActionType = _this$props.buttonActionType,
          toogleActionSize = _this$props.toogleActionSize,
          onAddFilter = _this$props.onAddFilter,
          multipleSize = _this$props.multipleSize,
          delayClose = _this$props.delayClose,
          delayOpen = _this$props.delayOpen,
          step = _this$props.step,
          toolBarAnimationDuration = _this$props.toolBarAnimationDuration,
          toolBarInteractionType = _this$props.toolBarInteractionType,
          toolBarPosition = _this$props.toolBarPosition,
          isMain = _this$props.isMain,
          toolTipZIndex = _this$props.toolTipZIndex;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          top = _this$state.top,
          right = _this$state.right;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.myRef,
        className: "".concat(cssClassName, " ").concat(mainModifier(condition ? 'active' : 'default'), " step-").concat(step, "  ").concat(isMain ? 'is-main-group-join' : '') // onMouseEnter={this.handleMouseEnterRow}
        ,
        onMouseLeave: this.handleMouseLeaveRow // onMouseMove={this.handleMouseMove}

      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classNameBlock('content'), " step-").concat(step)
      }, /*#__PURE__*/React.createElement(DSTooltip, {
        delayClose: delayClose,
        delayOpen: delayOpen,
        interactionType: toolBarInteractionType,
        isOpen: isOpen,
        onOpen: this.handleTooltipRow,
        placement: toolBarPosition,
        springAnimationComponent: /*#__PURE__*/React.createElement(ToolBarAnimation, {
          duration: toolBarAnimationDuration
        }),
        step: step,
        title: /*#__PURE__*/React.createElement("div", {
          ref: this.contenerRef,
          className: classNameBlock('actions'),
          style: {
            transition: '0.2s',
            position: 'absolute',
            top: "".concat(top, "px"),
            right: "".concat(right, "px")
          }
        }, /*#__PURE__*/React.createElement(DSButton, {
          buttonType: buttonActionType,
          className: classNameElement('add-rule'),
          icon: /*#__PURE__*/React.createElement(QueryAdd, null),
          onClick: onAddFilter,
          size: buttonActionSize,
          containerProps: {
            'data-testid': 'query-add-button'
          }
        }), allowUnGroup && /*#__PURE__*/React.createElement(DSButton, {
          buttonType: "text",
          className: classNameElement('ungroup'),
          icon: /*#__PURE__*/React.createElement(ParenthesisRemove, null),
          onClick: handleRuleContainerUnGroup,
          size: buttonActionSize,
          containerProps: {
            'data-testid': 'parenthesis-remove-button'
          }
        }), /*#__PURE__*/React.createElement(DSToggle, {
          checked: condition,
          className: classNameElement('and-or-toggle'),
          labelOff: labelOff,
          labelOn: labelOn,
          onChange: function onChange(e) {
            return handleRuleContainerOperator(e.target.checked);
          },
          size: toogleActionSize,
          containerProps: {
            'data-testid': 'and-or-toggle-button'
          }
        })),
        tooltipType: TooltipType.TOOLBAR,
        triggerComponent: /*#__PURE__*/React.createElement("div", {
          className: "".concat(classNameBlock('trigger-controller'), " ").concat(showDragController ? classNameBlockModifier('draggable', 'trigger-controller') : '', " step-").concat(step)
        }, /*#__PURE__*/React.createElement("div", {
          className: classNameElement('condition-display')
        }, /*#__PURE__*/React.createElement("span", {
          className: classNameElement('condition-display-label')
        }, condition ? labelOn : labelOff), /*#__PURE__*/React.createElement("span", {
          className: classNameElement('condition-display-step')
        }, step), /*#__PURE__*/React.createElement("div", {
          className: "separator"
        }), /*#__PURE__*/React.createElement(MoreOptionsVert, {
          color: DSIconColors.NEUTRAL,
          onClick: this.handleMouseEnterRow,
          size: DSIconSizes.S,
          containerProps: {
            'data-testid': 'and-or-more-options-button'
          }
        })), showDragController && /*#__PURE__*/React.createElement(DragContainerController, {
          multipleSize: multipleSize,
          onClick: this.handleMouseEnterRow
        })),
        zIndex: toolTipZIndex
      })));
    }
  }]);

  return AndOrController;
}(Component);

_defineProperty(AndOrController, "defaultProps", {
  isMain: false,
  handleRuleContainerOperator: function handleRuleContainerOperator() {
    return null;
  },
  handleRuleContainerUnGroup: function handleRuleContainerUnGroup() {
    return null;
  },
  handleTooltipGroup: function handleTooltipGroup() {
    return null;
  },
  labelOn: 'AND',
  labelOff: 'OR',
  condition: true,
  showDragController: true,
  allowUnGroup: true,
  buttonActionSize: DSIconSizes.M,
  buttonActionType: 'text',
  toogleActionSize: DSIconSizes.S,
  onAddFilter: function onAddFilter() {
    return null;
  },
  multipleSize: false,
  delayClose: DELAY_CLOSE,
  delayOpen: DELAY_OPEN,
  step: null,
  toolBarAnimationDuration: TOOLBAR_ANIMATION_DURATION,
  toolBarInteractionType: PopperInteractions.CLICK,
  toolBarPosition: PopperPositions.LEFT
});

export default AndOrController;
//# sourceMappingURL=AndOrController.js.map
